export default __webpack_public_path__ + "static/media/bemvindo.ec894052.svg";